import { atom, selector } from "recoil";
import { getCustomerSettings } from "../CustomerSettings";

export const layersVisibleState = atom({
  key: 'layersVisibleState',
  default: selector({
    key: 'layersVisibleStateSelector',
    get: () => {
      return getCustomerSettings('panel.layers');
    }
  })
});